import React, { useContext, useState } from 'react'
import reduce from 'lodash/reduce'
import PropTypes from 'prop-types'
import { Link, useStaticQuery, graphql } from 'gatsby'

import StoreContext from '~/context/StoreContext'

import { faBars } from '@fortawesome/free-solid-svg-icons'
import { NavItems, NavItem, NavLink, Logo, Wrapper, CartButton, CartIcon, HamburgerIcon, HeaderWrapper, AnnouncementBar } from './styles'
import { Container } from '~/styles/global'

// Components
import MobileNavbar from './MobileNavbar'

// MEDIA
import IcCart from '../../images/ic-cart.svg'

const useQuantity = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)

  const items = checkout ? checkout.lineItems : []
  const total = reduce(items, (acc, item) => acc + item.quantity, 0)
  return [total !== 0, total]
}

const Header = ({ siteTitle, floating, inverted, siteLaunched, hide }) => {
  const { markdownRemark } = useStaticQuery(
    graphql`
      query {
        markdownRemark(frontmatter: {
          cmsPartKey: {
            eq: "header"
          }
        }) {
          id
          frontmatter {
            enable_announcements
            announcement_text
          }
        }
      }
    `
  )

  const { enable_announcements, announcement_text } = markdownRemark.frontmatter;

  const [hasItems, quantity] = useQuantity()
  const [menuOpen, setMenuOpen] = useState(false)
  const { openCart } = useContext(StoreContext)

  const toggleMenuHandler = () => {
    if (menuOpen) {
      setMenuOpen(false)
    } else {
      setMenuOpen(true)
    }
  }

  if (hide) {
    return null;
  }


  return (
    <HeaderWrapper floating={floating}>
    {
      enable_announcements &&
      <AnnouncementBar>
        {announcement_text}
      </AnnouncementBar>
    }
      <Container>
        <Wrapper>
          <Logo to="/" inverted={inverted}>
            &SÜPA
          </Logo>
              <nav>
            <NavItems>
              <NavItem desktopOnly>
                <NavLink to="/about" inverted={inverted}>
                  ABOUT
                </NavLink>
              </NavItem>
              <NavItem desktopOnly>
                <NavLink to="/lookbook" inverted={inverted}>
                  LOOKBOOK
                </NavLink>
              </NavItem>
              <NavItem desktopOnly>
                <NavLink to="/shop" inverted={inverted}>
                  SHOP
                </NavLink>
              </NavItem>
              <NavItem desktopOnly>
                <NavLink to="/contact" inverted={inverted}>
                  CONTACT
                </NavLink>
              </NavItem>
              <NavItem>
                <CartButton onClick={openCart} inverted={inverted}>
                  <IcCart alt="A cart icon" />
                </CartButton>
              </NavItem>
              <NavItem mobileOnly>
                <HamburgerIcon inverted={inverted} icon={faBars} className="burger-icon" onClick={toggleMenuHandler} />
              </NavItem>
            </NavItems>
          </nav>
          <MobileNavbar toggleMenu={toggleMenuHandler} showMenu={menuOpen} />
        </Wrapper>
      </Container>
    </HeaderWrapper>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
